import { connect } from 'react-redux'
import { getLvpLayout } from '@chegg-wt/core/components/Layouts/LargeVideoPlayerLayout'
import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import { softGateStyle } from '@chegg-wt/core/state/currentProject/actions'
import { NextPageWithLayout } from '@chegg-wt/core/types/layout'
import { getSourceTypeName, sourceTypeById } from '@chegg-wt/core/utils/sourceTypes'
import { useRouter } from 'next/router'
import FormPage, { FormPageTop } from '@chegg-wt/core/components/Layouts/Form'
import { getUrlStyleNameV2 } from '@chegg-wt/core/api/oneGraph'
import { getActualStyleId, isStyleIdInValid } from '@chegg-wt/core/utils/styles'
import { NextPageContext } from 'next'
import React, { useEffect } from 'react'
import { shouldShowStyleGatedModalSelector } from '@chegg-wt/core/state/currentProject/selectors'
import MetaDescription from '@chegg-wt/core/components/Head/MetaDescription'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import { APA_ANNOTATED_BIBLIOGRAPHY } from '@chegg-wt/core/constants/styles'
import { AppState } from '@chegg-wt/core/state'
import { getSourceFromQuery } from '../../../utils/routes'
import { formB1 } from '../../../copy/CMSContent'

interface Props {
  styleFullName: string
  softGateStyle: typeof softGateStyle
  shouldShowStyleGatedModal: boolean
}

const CustomPage: NextPageWithLayout<Props> = ({
  styleFullName,
  softGateStyle,
  shouldShowStyleGatedModal,
}) => {
  const router = useRouter()
  const { source: sourceQuery, style } = router.query as { source: string; style: string }
  const source = getSourceFromQuery(router, sourceQuery)
  const formattedSource = getSourceTypeName(source).toLowerCase()
  const formattedStyle = styleFullName || style.toUpperCase()

  useOnUnloadTimeOnPage()
  useEffect(() => {
    if (shouldShowStyleGatedModal) softGateStyle(getActualStyleId(style), false) // compare url style with project citation style
  }, [style, shouldShowStyleGatedModal])
  return (
    <>
      <SEOTitle
        title={`BibMe: Generate ${formattedStyle} ${formattedSource} citations for your bibliography`}
      />
      <MetaDescription
        content={`BibMe lets you easily and automatically create ${formattedSource} citations and build your bibliography in ${styleFullName}. It’s accurate and free!`}
      />
      <FormPage
        route="toManualCitation"
        formType="manual"
        copy={formB1}
        currentUrlStyle={getActualStyleId(style)}
      />
    </>
  )
}

CustomPage.getPageLayout = (page) => getLvpLayout(page, () => <FormPageTop />)

export const getServerSideProps = async ({ query }: NextPageContext) => {
  const { style, source: sourceQuery } = query as { style: string; source: string }
  const [, styleFullName] = await getUrlStyleNameV2(style)
  const source = getSourceFromQuery({ route: '/[style]/[source]/custom' }, sourceQuery)

  return {
    props: {
      styleFullName,
    },
    notFound:
      style === APA_ANNOTATED_BIBLIOGRAPHY ||
      isStyleIdInValid(style) ||
      !sourceTypeById(source),
  }
}

const mapStateToProps = (state: AppState) => ({
  shouldShowStyleGatedModal: shouldShowStyleGatedModalSelector(state),
})

const mapDispatchToProps = {
  softGateStyle,
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomPage)
